import { useQuery } from '@tanstack/react-query';

import { getMatchupWinnerDeterminationInfo } from '@/infrastructure/network/data/matchups/matchup';

export const useMatchupWinnerDetermination = (matchupId: string) => {
	return useQuery({
		queryKey: ['MATCHUP_WINNER', matchupId],
		queryFn: () => getMatchupWinnerDeterminationInfo({ matchupUuid: matchupId }),
		enabled: !!matchupId
	});
};
